import { endpoints } from "config";

export const META_TITLE = "SodaStream Professional by PepsiCo";
export const META_DESCRIPTION =
  "SodaStream Professional is a connected hydration platform built to reflect how people drink water today -- there's been a rise in the consumption of water and low-and-no-sugar drinks. We also want to address the effects of plastic on the environment.";
export const CANONICAL_URL_BASE = endpoints.web;
export const META_DEFAULT_OG_IMAGE = `${endpoints.cdn}/sodastreampro/SSPMeta.png`;
export const PRIMARY_COLOR = `#009CDD`;
